import type { SelectRowAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { YinshState } from "../types/game-state";

function positionsMatch(
  a: readonly [string, string, string, string, string],
  b: readonly [string, string, string, string, string],
): boolean {
  const setA = new Set(a);
  const setB = new Set(b);
  // Require exactly 5 distinct positions and full mutual containment
  return setB.size === 5 && b.every((p) => setA.has(p));
}

export function validateSelectRow(
  state: YinshState,
  action: SelectRowAction,
): ValidationResult {
  if (state.phase !== "REMOVING_ROW") {
    return { valid: false, error: "Not in row removal phase" };
  }
  if (action.player !== state.currentPlayer) {
    return { valid: false, error: "Not your turn" };
  }
  if (state.pendingRows.length === 0) {
    return { valid: false, error: "No rows pending removal" };
  }
  const matches = state.pendingRows.some(
    (row) =>
      row.player === action.player &&
      positionsMatch(row.positions, action.positions),
  );
  if (!matches) {
    return { valid: false, error: "Selection does not match any pending row" };
  }
  return { valid: true };
}
